import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchAuthSession, getCurrentUser, signOut } from "../utils/authSession";
import Cookies from "js-cookie";
import Loader from "../components/Loader";

function RoleRedirect() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function redirectBasedOnRole() {
      try {
        Cookies.remove("impersonationToken");
        localStorage.removeItem("impersonatedUser");

        const session = await fetchAuthSession();
        const { accessToken } = session.tokens ?? {};
        const groups = accessToken?.payload["cognito:groups"] ?? [];
        const { userId } = await getCurrentUser();

        if (accessToken) {
          Cookies.set("accessToken", accessToken.toString(), {
            expires: 6 / 24,
            secure: true,
            sameSite: "Strict",
          });
          await new Promise((resolve) => setTimeout(resolve, 0));
        }

        if (groups.includes("ConvAI_Admin")) {
          navigate(`/geniehireadmin/dashboard`);
        } else if (groups.includes("Company_Admin")) {
          navigate(`/org-admin/dashboard`);
        } else if (groups.includes("HR")) {
          navigate(`/hr/dashboard`);
        } else {
          // Must clear the cookie before navigating back to "/" -- LoginPage
          // resumes any session it finds there, and signOut() alone doesn't
          // touch this cookie (it only revokes server-side), so without this
          // a valid-but-groupless token bounces forever between "/" and here.
          Cookies.remove("accessToken");
          await signOut();
          setTimeout(() => {
            navigate("/");
          }, 2000);
        }
      } catch (err) {
        navigate("/not-found");
      } finally {
        setLoading(false);
      }
    }
    redirectBasedOnRole();
  }, [navigate]);

  return loading ? <Loader /> : null;
}

export default RoleRedirect;
